import React, {forwardRef, ReactNode} from "react"
import Box from "@mui/material/Box"
import {SxProps, Theme} from "@mui/material"
import {useConfig} from "../../hooks/useConfig"
import {aspectRatioToNumeric} from "../../utils/AspectRatioUtil"

interface MediaContainerProps {
  sx?: SxProps<Theme>
  style?: React.CSSProperties
  children: ReactNode
}

const MediaContainer = forwardRef<HTMLDivElement, MediaContainerProps>(
  ({sx, style, children, ...rest}, ref) => {
    const config = useConfig()

    return (
      <Box
        ref={ref}
        style={style}
        {...rest}
        sx={{
          position: "relative",
          justifySelf: "center",
          width: 1,
          maxWidth: 720,
          aspectRatio: aspectRatioToNumeric(config.captureAspectRatio),
          borderRadius: 2,
          overflow: "hidden",
          mx: "auto",
          bgcolor: "rgba(0,0,0,0.25)",
          boxShadow: "0px 8px 10px rgba(0,0,0,0.25)",
          ...(sx as object),
        }}
      >
        {children}
      </Box>
    )
  },
)

MediaContainer.displayName = "MediaContainer"

export default MediaContainer
